import type { SelectOption } from '@diamond/shared/types';
import { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { buildLhcItemsFilter } from '../utils/build-lhc-params';
import { getDateRangeByPeriod } from '../utils/date-filter-period';

type LhcDetailFilterValues = {
  'invoice_date-from': string;
  'invoice_date-to': string;
};

export function useLhcDetailFilters() {
  const methods = useForm<LhcDetailFilterValues>({
    defaultValues: {
      'invoice_date-from': '',
      'invoice_date-to': '',
    },
  });
  const [plantFilter, setPlantFilter] = useState<SelectOption | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const [appliedFilters, setAppliedFilters] = useState({
    dateFrom: '',
    dateTo: '',
    plantFilter: null as SelectOption | null,
    appliedSearch: '',
  });

  const handleDateFilter = useCallback((period: string, baseDate?: Date) => {
    return getDateRangeByPeriod(period, baseDate);
  }, []);

  const updateDateParams = useCallback(
    (fromDate: string, toDate: string) => {
      methods.setValue('invoice_date-from', fromDate);
      methods.setValue('invoice_date-to', toDate);
    },
    [methods]
  );

  const handleSearch = useCallback(() => {
    setAppliedFilters({
      dateFrom: methods.getValues('invoice_date-from'),
      dateTo: methods.getValues('invoice_date-to'),
      plantFilter,
      appliedSearch: searchValue,
    });
  }, [methods, plantFilter, searchValue]);

  const apiParams = useMemo(() => {
    return buildLhcItemsFilter({
      dateFrom: appliedFilters.dateFrom,
      dateTo: appliedFilters.dateTo,
      plantFilter: appliedFilters.plantFilter,
      appliedSearch: appliedFilters.appliedSearch,
    });
  }, [appliedFilters]);

  return {
    apiParams,
    appliedFilters,
    handleDateFilter,
    handleSearch,
    methods,
    plantFilter,
    searchValue,
    setPlantFilter,
    setSearchValue,
    updateDateParams,
  };
}
